import { createAction, props } from '@ngrx/store';
import {
  PagedDiagnosticRemoteAssistanceDto,
  PagedIMonitorRemoteSupportSessionDto,
  PagedRemoteAssistanceVehiclesDto,
} from '@services/api/api.service';
import { PagedRemoteServiceListDto, RemoteServiceConsentDto } from '@services/api/sdf-remote-services-api.service';

// --------------------------------
// DEALER REMOTE SUPPORT
// --------------------------------

export const setRemoteSupportSessionsLoading = createAction(
  'setRemoteSupportSessionsLoading',
  props<{ isLoading: boolean }>(),
);

export const setRemoteSupportSessionsCompletedLoading = createAction(
  'setRemoteSupportSessionsCompletedLoading',
  props<{ isLoading: boolean }>(),
);

export const setRemoteSupportSessionsFilters = createAction(
  'setRemoteSupportSessionsFilters',
  props<{ filters: { qSearch?: string, startDate?: Date, endDate?: Date } }>(),
);

export const setRemoteSupportSessionsCompletedFilters = createAction(
  'setRemoteSupportSessionsCompletedFilters',
  props<{ filters: { qSearch?: string, startDate?: Date, endDate?: Date } }>(),
);

export const setRemoteSupportSessionsPaginator = createAction(
  'setRemoteSupportSessionsPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setRemoteSupportSessionsCompletedPaginator = createAction(
  'setRemoteSupportSessionsCompletedPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setRemoteSupportSessionsList = createAction(
  'setRemoteSupportSessionsList',
  props<{ response: PagedRemoteServiceListDto; }>(),
);

export const setRemoteSupportSessionsCompletedList = createAction(
  'setRemoteSupportSessionsCompletedList',
  props<{ response: PagedRemoteServiceListDto; }>(),
);

export const getRemoteSupportSessionsList = createAction(
  'getRemoteSupportSessionsList',
);

export const getRemoteSupportSessionsCompletedList = createAction(
  'getRemoteSupportSessionsCompletedList',
);

export const obtainWsRemoteSupportSessionStatus = createAction(
  'obtainWsRemoteSupportSessionStatus',
  props<{ vin: string; assistanceId: string }>(),
);

export const destroyWsRemoteSupportSessionStatus = createAction(
  'destroyWsRemoteSupportSessionStatus',
);

export const setRemoteSupportSessionStatus = createAction(
  'setRemoteSupportSessionStatus',
  props<{ status: any }>(),
);

export const setRemoteSupportSessionUrl = createAction(
  'setRemoteSupportSessionUrl',
  props<{ url: string }>(),
);

export const setRemoteSupportSessionConsent = createAction(
  'setRemoteSupportSessionConsent',
  props<{ consent: RemoteServiceConsentDto | null }>(),
);

// --------------------------------
// CUSTOMER REMOTE SUPPORT
// --------------------------------

export const setCustomerVehiclesLoading = createAction(
  'setCustomerVehiclesLoading',
  props<{ isLoading: boolean }>(),
);

export const setRemoteSupportSessionsCustomerLoading = createAction(
  'setRemoteSupportSessionsCustomerLoading',
  props<{ isLoading: boolean }>(),
);

export const setCustomerVehiclesFilters = createAction(
  'setCustomerVehiclesFilters',
  props<{ filters: { qSearch?: string } }>(),
);

export const setRemoteSupportSessionsCustomerFilters = createAction(
  'setRemoteSupportSessionsCustomerFilters',
  props<{ filters: { qSearch?: string, isCompleted?: boolean, startDate?: Date, endDate?: Date } }>(),
);

export const setCustomerVehiclesPaginator = createAction(
  'setCustomerVehiclesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setRemoteSupportSessionsCustomerPaginator = createAction(
  'setRemoteSupportSessionsCustomerPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setCustomerVehiclesList = createAction(
  'setCustomerVehiclesList',
  props<{ response: PagedRemoteAssistanceVehiclesDto; }>(),
);

export const setRemoteSupportSessionsCustomerList = createAction(
  'setRemoteSupportSessionsCustomerList',
  props<{ response: PagedIMonitorRemoteSupportSessionDto; }>(),
);

export const getCustomerVehiclesList = createAction(
  'getCustomerVehiclesList',
);

export const getRemoteSupportSessionsCustomerList = createAction(
  'getRemoteSupportSessionsCustomerList',
);
